import { styled } from "../stitches.config";

export const StyledText = styled("p", {
  fontFamily: "$content",
  text: "sm",
  color: "$neutral_700",
  margin: 0,
  variants: {
    isExtra: {
      true: { text: "xs", color: "$neutral_500" },
    },
    isError: {
      true: { text: "xs", color: "$primary_600" },
    },
  },
});
